module.exports = __webpack_public_path__ + "static/media/home2.daff8e05.png";